import React from "react";
import { Link } from "react-router-dom";
import { CreditCard2Front, ShieldCheck } from "react-bootstrap-icons";
import "../../styles/PaymentWidget.css";

export function PaymentWidget() {
  return (
    <div className="cp-payment-widget">
      <div className="cp-payment-widget__banner">
        <div className="cp-payment-widget__banner-left">
          <CreditCard2Front className="cp-payment-widget__banner-icon" />
          <div>
            <div className="cp-payment-widget__banner-title">
              Credit Card Payment
            </div>
            <div className="cp-payment-widget__banner-subtitle">
              Pay your contract with a credit card
            </div>
          </div>
        </div>
        <ShieldCheck className="cp-payment-widget__banner-trust" />
      </div>

      <div className="cp-payment-widget__body">
        <p className="cp-payment-widget__copy">
          Securely pay using a credit card. Opens in a new tab.
        </p>

        <Link
          to="/payment"
          target="_blank"
          rel="noopener"
          id="checkout_button"
          className="cp-payment-widget__cta"
        >
          Pay with Credit Card
        </Link>
      </div>
    </div>
  );
}
